import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import { Grid2 } from '@aibees/shared/components';
import { WhiteLabelTabs } from '@aibees/elephant/types';
import { WhiteLabelLeftSide } from '@aibees/elephant/feature';
import React, { useState } from 'react';
import * as Styled from './styles';
import { SaveWhiteLabel } from './components/save-white-label';
import { WhiteLabelLayoutProps } from './types';

export function WhiteLabelLayout({ tabs }: WhiteLabelLayoutProps) {
  const [value, setValue] = useState<WhiteLabelTabs>(WhiteLabelTabs.GENERAL);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue as WhiteLabelTabs);
  };

  return (
    <Styled.Wrapper container columns={12}>
      <Grid2 xs={12}>
        <SaveWhiteLabel />
      </Grid2>
      <Styled.Content container xs={12}>
        <TabContext value={value}>
          <Grid2 xs={12}>
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              {tabs.map((t) => (
                <Tab key={t.value} label={t.label} value={t.value} />
              ))}
            </TabList>
          </Grid2>
          <Styled.LeftSide xs={3}>
            <WhiteLabelLeftSide />
          </Styled.LeftSide>
          <Grid2 xs={9}>
            {tabs.map((t) => (
              <TabPanel key={t.value} value={t.value} sx={{ width: '100%' }}>
                {t.component}
              </TabPanel>
            ))}
          </Grid2>
        </TabContext>
      </Styled.Content>
    </Styled.Wrapper>
  );
}
